import React from 'react';
import { Link } from 'react-router-dom';
import { ShieldCheck, FileSearch, ArrowRight } from 'lucide-react';

export default function ServicesTeaser() {
  return (
    <section className="py-24 lg:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-2xl mb-12">
          <span className="text-[12.5px] uppercase tracking-[0.22em] font-semibold text-[#E85A18]">Med-Tech Advisory</span>
          <h2 className="mt-3 text-[34px] sm:text-[42px] lg:text-[50px] leading-[1.05] tracking-tight text-[#0F1B2D] font-semibold" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Beyond distribution — we help Med-Tech startups scale.
          </h2>
        </div>
        <div className="grid md:grid-cols-2 gap-6">
          <Card
            to="/services/soc2-questionnaires"
            icon={ShieldCheck}
            eyebrow="IT & Security"
            title="Medical AI IT / SOC2 Questionnaire expertise"
            body="End-to-end SOC2, HIPAA, DPDPA, HITRUST, ISO 27001 and hospital-custom questionnaire response — with evidence mapping and reusable answer libraries."
          />
          <Card
            to="/services/rfp-sales-enablement"
            icon={FileSearch}
            eyebrow="Xccelera · Go-to-Market"
            title="Xccelera — RFP creation & Sales enablement"
            body="Winning RFP responses, pricing models, clinical evidence packaging, and sales collateral tailored to hospital, insurer, and government Med-Tech buyers."
          />
        </div>
      </div>
    </section>
  );
}

function Card({ to, icon: Icon, eyebrow, title, body }) {
  return (
    <Link
      to={to}
      className="group relative overflow-hidden rounded-3xl border border-orange-100 bg-[#FFF9F1] p-8 lg:p-10 hover:bg-white hover:shadow-[0_30px_80px_-30px_rgba(232,90,24,0.35)] transition-all duration-500"
    >
      <div className="absolute -top-20 -right-16 w-64 h-64 rounded-full bg-[radial-gradient(closest-side,#FFD5B4,transparent_70%)] opacity-70 group-hover:opacity-100 transition-opacity" />
      <div className="relative">
        <div className="h-12 w-12 rounded-2xl bg-gradient-to-br from-[#FFB27A] to-[#E85A18] flex items-center justify-center">
          <Icon className="h-6 w-6 text-white" />
        </div>
        <div className="mt-6 text-[12px] uppercase tracking-widest text-[#E85A18] font-semibold">{eyebrow}</div>
        <h3 className="mt-2 text-[24px] lg:text-[28px] font-semibold text-[#0F1B2D] leading-tight" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
          {title}
        </h3>
        <p className="mt-3 text-[15px] leading-[1.65] text-slate-600 max-w-md">{body}</p>
        <div className="mt-6 inline-flex items-center gap-2 text-[14px] font-medium text-[#E85A18]">
          Learn more <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
        </div>
      </div>
    </Link>
  );
}
